import { cn } from "@/lib/utils";
import {
  ESTADO_EVENTO_LABEL,
  ESTADO_EVENTO_TONE,
} from "@/data/adminEventosStore";

/**
 * Badge institucional para el estado de un evento.
 * Tonos discretos, sin colores saturados.
 */
const TONE_CLASSES = {
  neutral:
    "bg-muted text-muted-foreground border border-border/60",
  info:
    "bg-primary/5 dark:bg-accent/10 text-primary dark:text-accent border border-primary/20 dark:border-accent/30",
  success:
    "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border border-emerald-500/30",
  warning:
    "bg-amber-500/10 text-amber-700 dark:text-amber-300 border border-amber-500/30",
  muted:
    "bg-muted/70 text-muted-foreground border border-border/60",
  danger:
    "bg-destructive/10 text-destructive border border-destructive/30",
};

export default function EstadoEventoBadge({ estado, className }) {
  const tone = ESTADO_EVENTO_TONE[estado] || "neutral";
  const label = ESTADO_EVENTO_LABEL[estado] || estado || "—";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5",
        "text-[11px] font-medium tracking-wide",
        TONE_CLASSES[tone],
        className,
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
